export default __webpack_public_path__ + "static/media/Art_Education-small.0f082e1c.jpeg";